import React, {Component} from 'react';
import {Button, Table, Modal, Card} from 'antd';
import {formatDate} from '../utils/index'
import {
    messageNotificationList,
    getAttachmentFiles,
    getNotificationById,
    updateReadStatus
} from "../actions/messageNotificationList";
import {Scrollbars} from "react-custom-scrollbars";
import './messageNotification.css'
import {HEADER_HEIGHT} from "../constants";

const start = 1;//从1第一页开始
const size = 10;//每页10条

class MessageNotification extends Component {
    reviewMessage = (messageData) => {
        updateReadStatus(messageData.id)
        if(messageData.noticficationId > 0){
            getNotificationById(messageData.noticficationId,res=>{
                if(res){
                    messageData.newTitle=res;
                    this.setState({modalVisible: true,messageDetail: messageData});
                }
            })
        }else{
            this.setState({modalVisible: true,messageDetail: messageData})
        }
    }

    columns = [
        {
            title: '标题',
            dataIndex: 'title',
            key: 'title',
            width:300,
            render: (text, record) => (
                <a onClick={() => this.reviewMessage(record)}>{text}</a>
            )
        },
        {
            title: '发送者',
            dataIndex: 'sender',
            key: 'sender',
            align:'center',
            width:100,
            render: (text, record) => (
                <span>
                    {record && record.senderInfo?record.senderInfo.name:record.sender}
                </span>
            )
        },
        {
            title: '发送时间',
            dataIndex: 'createTime',
            key: 'createTime',
            align:'center',
            width:170,
            render: (text, record) => (
                <span>
                    {text && formatDate(text.time)}
                </span>
            )
        },
        {
            title: '读取状态',
            dataIndex: 'isReadstatus',
            key: 'isReadstatus',
            width:90,
            render: (text, record) => (<span>
                    {text === 1 ? '已读' : '未读'}
                </span>
            )
        }
    ];

    constructor(props) {
        super(props);
        this.state = {
            start: start,
            size: size,
            total: 0,
            messageDetail: null,
            data: [],
            modalVisible: false,
            // params: this.props.match.params
        }
    }

    initDataSource = (page, pageSize) => this.paginationOnChange(page, pageSize);

    paginationOnChange(page, pageSize) {
        messageNotificationList(page, pageSize, (res) => {
            this.setState(() => {
                return {
                    start: page,
                    size: pageSize,
                    total: res.count,
                    data: (() => {
                        for (let i = 0; res.data && i < res.data.length; i++) {
                            //这个key是react的item必须的，如果没有这会按照索引来。但是复选框就会出问题了。
                            //当选择了某个选项，再翻页后，会将新页码中的数据也选中
                            if (!res.data[i].key) {
                                res.data[i].key = res.data[i].id;
                            }
                        }
                        return res.data;
                    })(),
                    selectedRows: []
                }
            })
        });
    }

    componentDidMount() {
        this.initDataSource(this.state.start, this.state.size);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        // this.state.params = nextProps.match.params
        this.initDataSource(this.state.start, this.state.size);
    }

    onOk = () => {
        this.setState({modalVisible: false, messageDetail: null})
    }
    onCancel = () => {
        this.setState({modalVisible: false, messageDetail: null})
    }

    reloadMessageData = () => {
        this.initDataSource(this.state.start, this.state.size);
    }

    render() {
        let pagination = {
            onChange: (page, pageSize) => this.paginationOnChange(page, pageSize),
            onShowSizeChange: (page, pageSize) => this.paginationOnChange(page, pageSize),
            defaultCurrent: 1,
            defaultPageSize: 10,
            current: this.state.start,
            pageSize: this.state.size,
            total: this.state.total,
            showQuickJumper: true, //快速跳转至某一页
            showSizeChanger: true,	//是否可以改变 pageSize
        };
        let margin = 15;
        let cardTitle = 60;
        let tableHeader = 80;
        let tableFooter = 90;
        let {showTitle} = this.props;
        let table = <Table dataSource={this.state.data}
                           columns={this.columns}
                           pagination={pagination}
                           scroll={showTitle?{y:document.body.clientHeight - HEADER_HEIGHT - margin * 2 - cardTitle - tableHeader - tableFooter}:undefined}
        />;
        let modal = this.state.messageDetail && <MessageNotificationModal modalVisible={this.state.modalVisible}
                                                                          onOk={this.onOk}
                                                                          onCancel={this.onCancel}
                                                                          reloadMessageData={this.reloadMessageData}
                                                                          messageDetail={this.state.messageDetail}/>;
        return (
            showTitle ? <div style={{margin}}>
                <Card title="消息通知">
                    {table}{modal}
                </Card>
            </div> : <div>{table}{modal}</div>
        )
    }
}

MessageNotification.defaultProps = {showTitle: true}

export class MessageNotificationModal extends Component {
    state = {
        content: [],
        fileList: []
    }
    downFile = (src) => {
        window.location = src + '?download=1';
    }

    setContentAndFileAttachment(messageDetail) {
        let content = messageDetail.content.replace(/<embed[^>]*vsbmp4video=[^>]*>/ig, function (videoEmbed) {
            return videoEmbed.replace("<embed", "<video").replace(/(.*)src=\"[^\"]*\"(.*)vsburl=\"([^\"]*)\"(.*)/, "$1 $2 src=\"$3\" $4</video>");
        }).replace(/<embed[^>]*vsbmp3audio=[^>]*>/ig, function (audioEmbed) {
            return audioEmbed.replace("<embed", "<audio").replace(/(.*)src=\"[^\"]*\"(.*)vsb_data=\"([^\"]*)\"(.*)/, "$1 $2 src=\"$3\"  controls=\"controls\" $4</audio>");
        });

        let attachmentResourceIds = messageDetail.attachmentResourceIds;
        if (attachmentResourceIds && attachmentResourceIds.length > 0) {
            getAttachmentFiles(messageDetail.id, (fileList) => {
                this.setState({fileList})
            });
        } else {
            this.setState({fileList: []})
        }

        this.setState({content})
    }

    componentDidMount() {
        this.setContentAndFileAttachment(this.props.messageDetail)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setContentAndFileAttachment(nextProps.messageDetail);
    }

    render() {
        const messageDetail = this.props.messageDetail;
        return (
            <Modal
                title="消息详情"
                centered
                width={800}
                visible={this.props.modalVisible}
                onOk={() => this.props.onOk()}
                onCancel={() => this.props.onCancel()}
                afterClose={() => this.props.reloadMessageData()}
            >
                <Scrollbars autoHeight autoHeightMax={550}>
                    <h1 style={{fontSize: 16}}>
                        {messageDetail.newTitle || messageDetail.title}
                    </h1>
                    <p>
                        <span>{formatDate(messageDetail.createTime.time)}</span>
                    </p>
                    <p dangerouslySetInnerHTML={{__html: this.state.content}}/>
                    <div>
                        {this.state.fileList.length > 0 && this.state.fileList.map((item, index) => {
                            return <div className="file" key={item.resourceId}
                                        style={{
                                            lineHeight: '25px',
                                            cursor: 'pointer',
                                            color: '#0050B3',
                                            textDecoration: 'underline'
                                        }}
                                        src={item.path} name={item.resourceId} id={item.resourceId}>
                                <div>
                                    <span onClick={() => this.downFile(item.path)}>{item.name}</span>
                                </div>
                            </div>
                        })}
                    </div>
                </Scrollbars>
            </Modal>
        );
    }
}

export default MessageNotification;
